"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _vuexModuleDecorators = require("vuex-module-decorators");
var _products = require("@/api/products");
var _index = _interopRequireDefault(require("@/components/HelpText/index.vue"));
var _router = _interopRequireDefault(require("@/router"));
var _leads = require("@/api/leads");
var _utils = require("@/utils");
require("tinymce/tinymce");
require("tinymce/themes/silver");
require("tinymce/icons/default");
require("tinymce/skins/ui/oxide/skin.css");
var _common = require("@/api/common");
var _index2 = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
var _tinymceVue = _interopRequireDefault(require("@tinymce/tinymce-vue"));
require("tinymce/plugins/lists");
require("tinymce/plugins/link");
require("tinymce/plugins/image");
require("tinymce/plugins/paste");
require("tinymce/plugins/help");
require("tinymce/plugins/wordcount");
require("tinymce/plugins/preview");
require("tinymce/plugins/table");
require("tinymce/plugins/code");
var _index3 = _interopRequireDefault(require("@/components/ImageMerger/index.vue"));
// plugins
// 'lists link image paste help wordcount preview table | code',

let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.rules = {};
    this.inputTagVisible = false;
    this.inputTagValue = '';
    this.selectedRelatedProduct = [];
    this.productsList = [];
    this.selectedFile = null;
    this.fileList = [];
    this.uploadFile = _common.uploadFile;
    this.drawingFileList = [];
    this.licenseFileList = [];
    this.licenseFile = null;
    this.previewUr = '';
    this.fileType = '';
    this.drawingFile = null;
    this.previewVisible = false;
    this.previewUrl = '';
  }
  handleDrawingRemove() {
    this.drawingFile = null;
    this.drawingFileList = [];
    this.formData.drawingFile = null;
  }
  handleDrawingChange(file) {
    this.drawingFile = file.raw;
    this.drawingFileList = [file];
  }
  handleLicenseChange(file) {
    this.licenseFile = file.raw;
    this.licenseFileList = [file];
  }
  handleLicenseRemove() {
    this.licenseFile = null;
    this.licenseFileList = [];
    this.formData.licenseFile = null;
  }
  get isPreviewDoc() {
    return ['doc', 'docx'].includes(this.fileType);
  }
  handlePreview(file) {
    // 1. Extract file extension
    const name = file.name || '';
    const extension = name.split('.').pop();
    this.fileType = extension ? extension.toLowerCase() : '';
    // 2. Determine URL (handle existing server URLs vs new local uploads)
    if (file.url) {
      this.previewUrl = file.url;
    } else if (file.raw) {
      this.previewUrl = URL.createObjectURL(file.raw);
    }
    this.previewVisible = true;
  }
  get isPreviewImage() {
    const images = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    return images.includes(this.fileType.toLowerCase());
  }
  get isPreviewPdf() {
    return this.fileType.toLowerCase() === 'pdf';
  }
  handleFileChange(file) {
    this.selectedFile = file.raw;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  created() {
    if (this.isEdit) {
      const productId = this.$route.params && this.$route.params.id;
      if (productId && +productId > 0) {
        this.fetchData(parseInt(productId));
      }
    }
  }
  async fetchData(id) {
    try {
      const data = await (0, _products.getProductById)(id);
      Object.assign(this.formData, data);
      // Related Products
      if (data.relatedProduct && data.relatedProduct.length) {
        this.selectedRelatedProduct = data.relatedProduct.map(relatedProduct => relatedProduct.id);
        const products = [];
        data.relatedProduct.forEach(value => {
          products.push({
            id: value.id,
            name: value.name
          });
        });
        this.productsList = products;
      }
      // Drawing File
      if (data.drawingFile) {
        this.drawingFileList = [{
          name: 'Drawing File',
          url: data.drawingFile
        }];
      }
      // License File
      if (data.licenseFile) {
        this.licenseFileList = [{
          name: 'License File',
          url: data.licenseFile
        }];
      }
    } catch (err) {} // eslint-disable-line no-empty
  }
  async getProductsList(query) {
    try {
      this.productsList = await (0, _products.getProducts)((0, _utils.getQuery)({
        enabled: true,
        name: query,
        filter: {
          enabled: 'eq',
          name: '$contL'
        }
      }));
    } catch (err) {} // eslint-disable-line  no-empty
  }
  handleProductTypeChange() {
    this.$emit('updated', this.formData);
  }
  remoteMethod(query) {
    this.getProductsList(query);
  }
  async saveForm() {
    this.loading = true;
    try {
      this.formData.relatedProduct = [];
      if (this.selectedRelatedProduct.length > 0) {
        this.selectedRelatedProduct.forEach(value => {
          this.formData.relatedProduct.push({
            id: value
          });
        });
      }
      // Upload Drawing File
      if (this.drawingFile) {
        const formData = new FormData();
        formData.append('file', this.drawingFile);
        const fileUrl = await (0, _common.uploadFile)(formData);
        this.formData.drawingFile = fileUrl;
      }
      // Upload License File
      if (this.licenseFile) {
        const formData = new FormData();
        formData.append('file', this.licenseFile);
        const fileUrl = await (0, _common.uploadFile)(formData);
        this.formData.licenseFile = fileUrl;
      }
      const response = await (0, _products.updateProduct)(this.formData.id, this.formData);
      this.formData = response;
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'saved',
        type: 'success',
        duration: 2000
      });
      this.$emit('updated', this.formData);
      if (this.$route.query && this.$route.query.followUpRedirect) {
        const leadId = +this.$route.query.followUpRedirect;
        await (0, _leads.productSourced)({
          id: leadId,
          productId: this.formData.id
        });
        _router.default.push('/follow-ups/list/' + leadId);
      } else {
        _router.default.push({
          path: '/product/list',
          query: this.$route.query
        });
      }
    } catch (err) {
      this.$notify.error(err.toString());
    } finally {
      this.loading = false;
    }
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  showTagInput() {
    this.inputTagVisible = true;
    this.focusTagInput();
  }
  focusTagInput() {
    this.$nextTick(() => {
      this.$refs.saveTagInput.$refs.input.focus();
    });
  }
  handleTagInputConfirm(event) {
    const inputValue = this.inputTagValue;
    if (inputValue) {
      let tags = [];
      if (this.formData.tags) {
        tags = this.formData.tags.split(',');
      }
      // push if not exist
      if (tags.indexOf(inputValue) === -1) {
        tags.push(inputValue);
      } else {
        this.$message({
          showClose: true,
          message: inputValue + ' already exist!',
          type: 'warning'
        });
      }
      this.formData.tags = tags.join(',');
    }
    this.inputTagValue = '';
    // if entered
    if (event.keyCode && event.keyCode === 13) {
      this.focusTagInput();
    } else {
      this.inputTagVisible = false;
    }
  }
  handleTagClose(tag) {
    const tags = this.formData.tags.split(',');
    this.formData.tags = tags.splice(tags.indexOf(tag), 1).join(',');
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: {}
})], default_1.prototype, "formData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ProductAdvanceTab',
  components: {
    HelpText: _index.default,
    Editor: _tinymceVue.default,
    FileUpload: _index2.default,
    ImageMerger: _index3.default
  }
})], default_1);
var _default = exports.default = default_1;